var axios = require('axios')
import moment from 'moment'
const urlGameInfo = process.env.version + '/product-coupon-fe/game-info/'
const urlPlay = process.env.version + '/product-coupon-fe/play-game/'
const urlHistory = process.env.version + '/product-coupon-fe/history'
const urlGame = process.env.version + '/product-customer/jp-grant-slices'

axios.options.flag = false

axios.getGameInfo = function (uuid, token, success, callBackError) {
  axios.options.flag = false
  var url = urlGameInfo + uuid;

  const auth = {
    headers: {
      'x-token': token
    }
  }

  this.get(url, auth)
      .then(response => {
        success(response)
      }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}
axios.playGame = function (uuid, token, success, callBackError) {
  axios.options.flag = false
  const auth = {
    headers: {
      'x-token': token
    }
  }

  let data = {
    uuid: uuid,
    current_date: moment().format('YYYY-MM-DD')
  }

  this.post(urlPlay, data, auth)
      .then(response => {
        success(response)
      }).catch(error => {
        if (error.response && (error.response.status == 400 || error.response.status == 404) && typeof callBackError !== 'undefined') {
          if (typeof callBackError !== 'undefined') {
            callBackError(error.response.data)
          }
        }
      })
}
axios.getHistory = function (uuid, data, success, callBackError) {
  axios.options.flag = false
  this.get(urlMenu + '/' + uuid, {params: data}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

axios.getSliceFromGame = function (data, token, success, callBackError) {
  if (token) {
    axios.defaults.headers['x-token'] = token
  }
  this.post(urlGame, data)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status === 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

export default axios



// WEBPACK FOOTER //
// ./src/api/SlotGame.js